import component from './zh-CN/component';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import indexPage from './zh-CN/indexPage';
import login from './zh-CN/login';
import register from './zh-CN/register';
import forgotPassword from './zh-CN/forgotPassword';
import authError from './zh-CN/authError';
import ai from './zh-CN/ai';
import assets from './zh-CN/assets';
import memberAsset from './zh-CN/memberAsset';
import creativeVideo from './zh-CN/creativeVideo';
import creativeImage from './zh-CN/creativeImage';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';

export default {
  /** 顶栏语言切换（SelectLang 触发器文案） */
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  ...pages,
  ...indexPage,
  ...login,
  ...register,
  ...forgotPassword,
  ...authError,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...ai,
  ...assets,
  ...memberAsset,
  ...creativeVideo,
  ...creativeImage,
};
